import { RealtimeContext } from "@/providers/RealtimeProvider";
import type { RealtimeContextType } from "@/types/providers/realtime";
import { useContext } from "react";

export default function useRealtime() {
  const context = useContext(RealtimeContext) as RealtimeContextType;
  if (!context) throw new Error("useRealtime must be used within an realtimeProvider");
  return context;
}
